module.exports = __webpack_public_path__ + "static/media/fullscreen-vod.219b2c28.svg";